import { F18_SERVICES } from '../configs/Config'
import { apiCMSWithToken } from './axios'

export const url = {
  footer: `/footer`
}

export async function listFooter(filters = {}) {
  try {
    const params = new URLSearchParams(filters).toString()
    const response = await apiCMSWithToken.get(`${url.footer}?${params}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function footerAdd(body) {
  const response = await apiCMSWithToken.post(`${url.footer}`, body)
  return response
}
export async function footerPosition(body) {
  const response = await apiCMSWithToken.post(`${url.footer}/position`, body)
  return response
}

export async function footerDelete(id) {
  try {
    const response = await apiCMSWithToken.delete(`${url.footer}/${id}`)
    return response
  } catch (error) {
    console.error('Error in postSearch:', error)
    throw error
  }
}

export async function footerActive(body) {
  const response = await apiCMSWithToken.post(`${url.footer}/active-area`, body)
  return response
}

export default {
  listFooter,
  footerAdd,
  footerPosition,
  footerDelete,
  footerActive
}
